import { render, staticRenderFns } from "./users-list.vue?vue&type=template&id=2bcd7530&"
import script from "./users-list.vue?vue&type=script&lang=js&"
export * from "./users-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports